<template>
  <div>
    <h4 class="mb-1">
      Аудит идентичности
    </h4>
    <b-alert
      v-if="errorText"
      show
      variant="danger"
    >
      {{ errorText }}
    </b-alert>
    <b-form-input
      v-model="action"
      class="w-25 mb-1"
      placeholder="action"
      @keyup.enter="fetch"
    />
    <b-table
      :items="rows"
      :fields="fields"
      :busy="loading"
      striped
      responsive
      empty-text="Записей нет"
    >
      <template #cell(created_at)="data">
        {{ data.item.created_at }}
      </template>
    </b-table>
  </div>
</template>

<script>
import {
  BAlert,
  BFormInput,
  BTable,
} from 'bootstrap-vue'
import identityApi from '@/services/identity-api.service'

export default {
  name: 'IdentityAuditPage',
  components: {
    BAlert,
    BFormInput,
    BTable,
  },
  data() {
    return {
      loading: false,
      errorText: '',
      action: '',
      rows: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'action', label: 'Действие' },
        { key: 'entity_type', label: 'Сущность' },
        { key: 'entity_id', label: 'ID сущности' },
        { key: 'actor_user_id', label: 'Актор' },
        { key: 'created_at', label: 'Время' },
      ],
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      this.errorText = ''
      try {
        const { data } = await identityApi.getAudit({ action: this.action || undefined, maxResultCount: 50 })
        this.rows = data.rows || []
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Ошибка загрузки'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
